import moment from 'moment';

/**
 * Formats a date using Moment.js with case handling.
 * @param {Date | string | number} date - The date to format.
 * @param {string} format - The desired format string.
 * @param {string} fallback - The value to return if the date is invalid.
 * @returns {string}
 */
export function formatDate(date, format = 'DD/MM/YYYY', fallback = 'NA') {
    // Check for null, undefined, or empty string
    if (!date) return fallback;
const formattedDate = formatUtcDate(date)
    const m = moment(formattedDate);
    // Check if the date is valid
    if (!m.isValid()) return fallback;
    if (m.year() < 1900) return fallback;

    return m.format(format);
}

export const formatUtcDate = (value) => {
    if (!value || typeof value !== "string") return value;
    return value.includes("Z") ? value : `${value}Z`;
};
